module.exports = __webpack_public_path__ + "static/img/9.2b1db10.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/4/eng/9.png
// module id = PwJy
// module chunks = 0